/**
 * Tiempo Unix sincronizado entre espectadores (offset SNTP en window._serverTimeOffset).
 * TV: script clásico (window.RAPTV_SYNC). Admin: import con `export {}` en el bundle ESM.
 */
(function (w) {
  function getServerTimeOffsetMs() {
    return w._serverTimeOffset || 0;
  }

  function getSyncedNowMs() {
    return Date.now() + getServerTimeOffsetMs();
  }

  function getSyncedNowSeconds() {
    return getSyncedNowMs() / 1000;
  }

  /** @param {Array} videos
   *  @param {(video: object, index: number) => number} [resolveDuration]
   */
  function totalDuration(videos, resolveDuration) {
    return videos.reduce((sum, v, i) => {
      const d = resolveDuration ? resolveDuration(v, i) : v.duration || 0;
      return sum + (d > 0 ? d : 0);
    }, 0);
  }

  /**
   * @param {number} elapsed segundos dentro del ciclo (ya en [0, total))
   * @returns {{ videoIndex: number, offsetInVideo: number }}
   */
  function findSlotAtElapsed(elapsed, videos, resolveDuration) {
    let accumulated = 0;
    for (let i = 0; i < videos.length; i++) {
      const d = resolveDuration ? resolveDuration(videos[i], i) : videos[i].duration || 0;
      if (d <= 0) continue;
      if (elapsed < accumulated + d) {
        return { videoIndex: i, offsetInVideo: elapsed - accumulated };
      }
      accumulated += d;
    }
    if (!videos.length) return { videoIndex: 0, offsetInVideo: 0 };
    return { videoIndex: videos.length - 1, offsetInVideo: 0 };
  }

  w.RAPTV_SYNC = {
    getServerTimeOffsetMs,
    getSyncedNowMs,
    getSyncedNowSeconds,
    totalDuration,
    findSlotAtElapsed,
  };
})(typeof window !== 'undefined' ? window : globalThis);
